import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "gird flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "col-12 md:col-6 lg:col-6 p-10" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Register", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Pendaftaran User Baru")
  ])
], -1)
const _hoisted_8 = { class: "m-5" }
const _hoisted_9 = { class: "field grid" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "col-12 mb-2 md:col-4 md:mb-0"
}, "Username *", -1)
const _hoisted_11 = { class: "col-12 md:col-8" }
const _hoisted_12 = { class: "field grid" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "col-12 mb-2 md:col-4 md:mb-0"
}, "Email *", -1)
const _hoisted_14 = { class: "col-12 md:col-8" }
const _hoisted_15 = { class: "field grid" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "col-12 mb-2 md:col-4 md:mb-0"
}, "Nama Lengkap *", -1)
const _hoisted_17 = { class: "col-12 md:col-8" }
const _hoisted_18 = { class: "field grid" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "col-12 mb-2 md:col-4 md:mb-0"
}, "Password *", -1)
const _hoisted_20 = { class: "col-12 md:col-8" }
const _hoisted_21 = { class: "field grid" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirm_password",
  class: "col-12 mb-2 md:col-4 md:mb-0"
}, "Confirm Password *", -1)
const _hoisted_23 = { class: "col-12 md:col-8" }
const _hoisted_24 = {
  key: 0,
  class: "field grid"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "roles",
  class: "col-12 mb-2 md:col-4 md:mb-0"
}, "Roles", -1)
const _hoisted_26 = { class: "col-12 md:col-8" }
const _hoisted_27 = { class: "text-center mt-5" }

export function render(_ctx, _cache) {
  const _component_p_message = _resolveComponent("p-message")
  const _component_p_inputtext = _resolveComponent("p-inputtext")
  const _component_p_multiselect = _resolveComponent("p-multiselect")
  const _component_p_button = _resolveComponent("p-button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_p_card = _resolveComponent("p-card")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_p_card, { class: "card" }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.app_base_data.app_name), 1)
        ]),
        subtitle: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.app_base_data.company_name), 1)
        ]),
        content: _withCtx(() => [
          _createElementVNode("h5", _hoisted_3, [
            (_ctx.app_base_data.main_icon !== '')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "rounded-circle shadow-4-strong",
                  alt: "avatar2",
                  width: "90",
                  height: "90",
                  src: _ctx.app_base_data.main_icon
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            _createTextVNode(),
            _hoisted_5,
            _hoisted_6
          ]),
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, [
            (_ctx.error)
              ? (_openBlock(), _createBlock(_component_p_message, {
                  key: 0,
                  severity: "error"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.error), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.success)
              ? (_openBlock(), _createBlock(_component_p_message, {
                  key: 1,
                  severity: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.success), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.success)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 2,
                  onSubmit: _cache[6] || (_cache[6] = _withModifiers((...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_p_inputtext, {
                        class: _normalizeClass([{'p-invalid' : _ctx.errors?.username}, "w-full border-solid border-round"]),
                        modelValue: _ctx.username,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.username) = $event)),
                        id: "username",
                        type: "text",
                        size: "small"
                      }, null, 8, ["class", "modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors?.username, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "text-red-600",
                          key: index
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_p_inputtext, {
                        class: _normalizeClass([{'p-invalid' : _ctx.errors?.email}, "w-full border-solid border-round"]),
                        modelValue: _ctx.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.email) = $event)),
                        id: "email",
                        type: "text",
                        size: "small"
                      }, null, 8, ["class", "modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors?.email, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "text-red-600",
                          key: index
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_p_inputtext, {
                        class: _normalizeClass([{'p-invalid' : _ctx.errors?.name}, "w-full border-solid border-round"]),
                        modelValue: _ctx.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.name) = $event)),
                        id: "name",
                        type: "text",
                        size: "small"
                      }, null, 8, ["class", "modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors?.name, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "text-red-600",
                          key: index
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_p_inputtext, {
                        class: _normalizeClass([{'p-invalid' : _ctx.errors?.password}, "w-full border-solid border-round"]),
                        modelValue: _ctx.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.password) = $event)),
                        id: "password",
                        type: "password",
                        size: "small"
                      }, null, 8, ["class", "modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors?.password, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "text-red-600",
                          key: index
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_p_inputtext, {
                        class: _normalizeClass([{'p-invalid' : _ctx.errors?.confirm_password}, "w-full border-solid border-round"]),
                        modelValue: _ctx.confirm_password,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.confirm_password) = $event)),
                        id: "confirm_password",
                        type: "password",
                        size: "small"
                      }, null, 8, ["class", "modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors?.confirm_password, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "text-red-600",
                          key: index
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ])
                  ]),
                  (_ctx.app_base_config.register.show_role)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_p_multiselect, {
                            id: "roles",
                            modelValue: _ctx.user_roles,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.user_roles) = $event)),
                            class: _normalizeClass([{'p-invalid' : _ctx.errors?.roles}, "w-full border-solid border-round"]),
                            options: _ctx.roles,
                            filter: "",
                            optionLabel: "name",
                            placeholder: "Select Roles",
                            maxSelectedLabels: 3
                          }, null, 8, ["modelValue", "class", "options"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors?.roles, (item, index) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "text-red-600",
                              key: index
                            }, _toDisplayString(item), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_p_button, {
                    onClick: _ctx.submit,
                    icon: _ctx.is_loading ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-upload',
                    disabled: _ctx.is_loading,
                    label: "Register",
                    class: "w-full",
                    severity: "success",
                    size: "small",
                    outlined: "",
                    rounded: ""
                  }, null, 8, ["onClick", "icon", "disabled"])
                ], 32))
              : (_openBlock(), _createBlock(_component_p_button, {
                  key: 3,
                  onClick: _cache[7] || (_cache[7] = $event => (_ctx.success = false)),
                  class: "w-full",
                  label: "New Register",
                  severity: "warning",
                  outlined: "",
                  rounded: ""
                })),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_router_link, { to: "/login" }, {
                default: _withCtx(() => [
                  _createTextVNode("---LOGIN---")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}